import { ReactNode, useState } from 'react';
import { useMutation } from '@apollo/client';
import { CalculateCharges } from '~/graphql';
import { CalculateChargesInput, CalculateChargesResponse } from './types';
import { ChargesContext } from './ChargesContext';

export const ChargesProvider = ({ children }: { children: ReactNode }) => {
    const [result, setResult] = useState<CalculateChargesResponse | null>(null);
    const [error, setError] = useState<Error | null>(null);

    const [calculateChargesMutation, { loading }] = useMutation<
        { calculateCharges: CalculateChargesResponse },
        { input: CalculateChargesInput }
    >(CalculateCharges);

    const calculateCharges = async (input: CalculateChargesInput) => {
        setError(null);
        try {
            console.log('input', input);

            const { data } = await calculateChargesMutation({ variables: { input } });
            console.log('data', data);

            if (data?.calculateCharges) {
                setResult(data.calculateCharges);
            }
        } catch (err) {
            setError(err as Error);
            setResult(null);
        }
    };

    return (
        <ChargesContext.Provider value={{ calculateCharges, result, loading, error }}>
            {children}
        </ChargesContext.Provider>
    );
};
